import { render } from "./IconBack.vue?vue&type=template&id=6858ade6"
import script from "./IconBack.vue?vue&type=script&lang=js"
export * from "./IconBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__